module.exports = __webpack_public_path__ + "img/01.37114fbe.jpg";